import { queryOptions } from '@tanstack/react-query';
import { fetchApi } from '@/std/api/fetchApi';
import { registrosSchema } from '@/std/schema';
import { TabelaComissaoProdutoSchema } from '../types/TabelaComissaoProduto';

export type TabelaComissaoProdutoGetParams = {
    produto_idpk: number;
    tabela_preco_idpk?: number;
};

const schema = registrosSchema(TabelaComissaoProdutoSchema);

function apiTabelaComissaoProdutoGet(params: TabelaComissaoProdutoGetParams) {
    return fetchApi({
        endpoint: 'TabelaComissao/Produto',
        method: 'get',
        params,
        schema,
    });
}

export const API_TABELA_COMISSAO_PRODUTO_GET_KEY = 'apiTabelaComissaoProdutoGet';

export function apiTabelaComissaoProdutoGetQueryOptions(params: TabelaComissaoProdutoGetParams) {
    return queryOptions({
        queryFn: () => apiTabelaComissaoProdutoGet(params),
        queryKey: [API_TABELA_COMISSAO_PRODUTO_GET_KEY, params],
    });
}
